import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { setLanguage, SUPPORTED_LANGUAGES } from "@/i18n";

export const LanguageSwitcher = ({ className = "", testId = "header-language-switcher" }) => {
  const { t, i18n } = useTranslation();
  const current = SUPPORTED_LANGUAGES.includes(i18n.language)
    ? i18n.language
    : "nl";

  return (
    <Select value={current} onValueChange={setLanguage}>
      <SelectTrigger
        aria-label={t("language.label")}
        data-testid={testId}
        className={`h-9 w-[150px] rounded-full bg-card/60 ${className}`}
      >
        <Languages className="mr-1 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_LANGUAGES.map((lang) => (
          <SelectItem key={lang} value={lang} data-testid={`language-option-${lang}`}>
            {t(`language.${lang}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
